import { useState } from 'react';

import { getCdnUrl } from '@/helpers';
import { IUpsell } from '@/interfaces/upsell';
import styled, { StyledProp } from '@/styled';

import Modal from './Modal';
import ImageRatio from '../ImageRatio';

interface IOfferCardProps {
  data: IUpsell;
  isLoading: boolean;
}

const OfferCard = ({ className, data, isLoading }: StyledProp & IOfferCardProps) => {
  const [open, setOpen] = useState(false);

  const toggleModal = () => setOpen(isOpened => !isOpened);

  if (isLoading || Object.keys(data ?? {}).length === 0) {
    return null;
  }

  const currentImage = getCdnUrl(data?.showcase_image ?? '');

  return (
    <div className={className}>
      <Modal data={data} isLoading={isLoading} open={open} onCancel={toggleModal} />

      <ImageRatio aspect='1:1' src={currentImage} alt={`Imagem da oferta: ${data?.title}`} onClick={toggleModal} />
    </div>
  );
};

export default styled(OfferCard)`
  width: calc(100% - 48px);
  margin: 0 auto;

  img {
    cursor: pointer;
  }
`;
